import React from 'react'

export function useHubspotChat (portalId) {
  const [hasLoaded, setHasLoaded] = React.useState(false)
  const [activeConversation, setActiveConversation] = React.useState(false)
  const eventRef = React.useRef(null)

  React.useEffect(() => {
    // Add event listener.
    window.hsConversationsOnReady = [() => {
      setHasLoaded(true)
    }]

    // Create script component.
    // let script = document.createElement('script')
    // script.src = `//js.hs-scripts.com/${portalId}.js`
    // script.async = true
    let script = document.createElement('script')
    script.setAttribute('data-ccm-loader-src',"https://js.hs-scripts.com/"+portalId+".js")
    script.setAttribute('type','text/x-ccm-loader')
    script.setAttribute('data-ccm-loader-group','data-ccm-loader-group-hubspot')

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
      window.hsConversationsOnReady = []
    }

  }, [portalId])

  // Subscribe to conversation events.
  React.useEffect(() => {
    eventRef.current = (payload) => {
      setActiveConversation(payload.conversation.conversationId)
    }

    if (hasLoaded) {
      window.HubSpotConversations?.on('conversationStarted', eventRef.current)
    }

    return () => {
      window.HubSpotConversations?.off('conversationStarted', eventRef.current)
    }

  }, [hasLoaded])

  const openHandler = React.useCallback(() => {
    if (hasLoaded) {
      window.HubSpotConversations.widget.open()
    }
  }, [hasLoaded])

  const closeHandler = React.useCallback(() => {
    if (hasLoaded) {
      window.HubSpotConversations.widget.close()
    }
  }, [hasLoaded])

  const refreshHandler = React.useCallback(() => {
    if (hasLoaded && window.hasOwnProperty('HubSpotConversations')) {
      window.HubSpotConversations.widget.refresh()
    }
  }, [hasLoaded])

  return {
    hasLoaded,
    activeConversation,
    refreshHandler,
    openHandler,
    closeHandler
  }
}
